<template>
  <div class="site">
    <form class="col-12" @submit.prevent="handleSubmit" v-if="site">
      <div class="row">
        <div class="col-6">
          <h2>Site Detail</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h3>Site Name</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="name">Name:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            ref="site_name"
            placeholder="name"
            :value="getName()"
          />
        </div>
        <div
          v-if="submitted && errors.has('name')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("name") }}
        </div>
      </div>
      <div>
        <template v-for="schedule_round in site_jobs">
          <div class="row" :key="schedule_round.id">
            <div class="col-2">
              <label>Round:</label>
            </div>
            <div class="col-9">
              <input
                type="text"
                class="form-control"
                enabled="false"
                :value="getRoundName(schedule_round)"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="row">
        <div class="col-12">
          <h3>Site Address</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="address1">Address 1:</label>
        </div>
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            id="address1"
            ref="site_address1"
            name="address1"
            placeholder=""
            :value="getAddressLine1()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="address2">Address 2:</label>
        </div>
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            id="address2"
            ref="site_address2"
            name="address2"
            placeholder=""
            :value="getAddressLine2()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="address3">Address 3:</label>
        </div>
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            id="address3"
            ref="site_address3"
            name="address3"
            placeholder=""
            :value="getAddressLine3()"
          />
        </div>
      </div>
      <div class="row">
        <div class=" col-2">
          <label for="city">City:</label>
        </div>
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            id="city"
            ref="site_city"
            name="city"
            placeholder="city"
            :value="getAddressCity()"
          />
        </div>
        <div class=" col-1">
          <label for="state">State:</label>
        </div>
        <div class="col-1 no-padding">
          <input
            type="text"
            class="form-control"
            id="state"
            ref="site_state"
            name="state"
            placeholder="state"
            :value="getAddressState()"
          />
        </div>
        <div class=" col-2">
          <label for="postcode">Postcode:</label>
        </div>
        <div class="col-1 no-padding">
          <input
            type="text"
            class="form-control"
            id="postcode"
            ref="site_postcode"
            name="postcode"
            placeholder="0000"
            :value="getAddressPostcode()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h3>Other Information</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="contact">Contact:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="contact"
            ref="site_contact"
            name="contact"
            placeholder="contact"
            :value="getContactName()"
          />
        </div>
        <div
          v-if="submitted && errors.has('contact')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("contact") }}
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="phone">Phone:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="phone"
            ref="site_phone"
            name="phone"
            placeholder="phone"
            :value="getPhone()"
          />
        </div>
        <div
          v-if="submitted && errors.has('phone')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("phone") }}
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="notes">Notes:</label>
        </div>
        <div class="col-9">
          <textarea
            rows="4"
            class="form-control"
            id="notes"
            ref="site_notes"
            name="notes"
            placeholder="notes"
            :value="getNotes()"
          />
        </div>
        <div
          v-if="submitted && errors.has('notes')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("notes") }}
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">
          New
        </button>
        <button v-if="site" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>
      <div class="col-2" v-if="site">
        <button
          id="delete"
          v-if="site.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "SiteDetail",
  props: {
    site: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    submitted: false,
    site_jobs: [],
  }),
  mounted: function() {
    if (this.site == null) {
      this.site_jobs = [];
    } else {
      this.site_jobs = this.getJobsForSite(this.site.id);
    }
  },
  watch: {
    site() {
      if (this.site == null) {
        this.site_jobs = [];
      } else {
        this.site_jobs = this.getJobsForSite(this.site.id);
      }
    },
    schedule_rounds() {
      if (this.site == null) {
        this.site_jobs = [];
      } else {
        this.site_jobs = this.getJobsForSite(this.site.id);
      }
    },
    available_jobs() {
      if (this.site == null) {
        this.site_jobs = [];
      } else {
        this.site_jobs = this.getJobsForSite(this.site.id);
      }
    },
  },
  computed: {
    ...mapGetters("schedule", ["getJobsForSite"]),
    ...mapState("schedule", ["schedule_rounds", "available_jobs"]),
  },
  methods: {
    ...mapActions("sites", ["apiSaveSite", "apiCreateSite"]),
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save();
        }
      });
    },
    getName() {
      if (!this.site) {
        return "";
      }
      return this.site.name;
    },
    getRoundName(schedule_round) {
      var result = schedule_round.round.name;
      result +=
        " - week " +
        (schedule_round.week_index + 1) +
        " - day " +
        (schedule_round.day_index + 1);
      schedule_round.personnels.forEach(personnel => {
        result += " - " + personnel.name;
      });
      return result;
    },
    getAddressLine1() {
      if (!this.site || !this.site.address) {
        return "";
      }
      return this.site.address.address1;
    },
    getAddressLine2() {
      if (!this.site || !this.site.address) {
        return "";
      }
      return this.site.address.address2;
    },
    getAddressLine3() {
      if (!this.site || !this.site.address) {
        return "";
      }
      return this.site.address.address3;
    },
    getAddressCity() {
      if (!this.site || !this.site.address) {
        return "";
      }
      return this.site.address.city;
    },
    getAddressState() {
      if (!this.site || !this.site.address) {
        return "";
      }
      return this.site.address.state;
    },
    getAddressPostcode() {
      if (!this.site || !this.site.address) {
        return "";
      }
      return this.site.address.postcode;
    },
    getContactName() {
      if (!this.site) {
        return "";
      }
      return this.site.contact;
    },
    getPhone() {
      if (!this.site) {
        return "";
      }
      return this.site.phone;
    },
    getNotes() {
      if (!this.site) {
        return "";
      }
      return this.site.notes;
    },
    _delete() {
      if (this.site && this.site.id > 0) {
        this.site.active = !this.site.active;
        this.apiSaveSite(this.site);
      }
    },
    save() {
      if (this.site) {
        this.site.name = this.$refs.site_name.value;
        this.site.notes = this.$refs.site_notes.value;
        this.site.contact = this.$refs.site_contact.value;
        this.site.phone = this.$refs.site_phone.value;
        if (!this.site.address) {
          this.site.address = {
            active: true,
            id: 0,
          };
        }
        this.site.address.address1 = this.$refs.site_address1.value;
        this.site.address.address2 = this.$refs.site_address2.value;
        this.site.address.address3 = this.$refs.site_address3.value;
        this.site.address.city = this.$refs.site_city.value;
        this.site.address.state = this.$refs.site_state.value;
        this.site.address.postcode = this.$refs.site_postcode.value;

        if (this.site.id > 0) {
          this.apiSaveSite(this.site);
        } else {
          this.apiCreateSite(this.site);
        }
        this.$emit("saved");
      }
    },
  },
  components: {},
};
</script>
